/**
 * Breadcrumb — Navigation breadcrumb cho cả internal + commercial
 * Hiển thị path hiện tại, clickable để quay lại
 */

import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import type { BreadcrumbItem } from '../../hooks/useHashRouter';

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate: (hash: string) => void;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, onNavigate }) => {
  if (items.length === 0) return null;

  return (
    <nav className="flex items-center gap-1 text-sm min-w-0" aria-label="Breadcrumb">
      {/* Home icon */}
      <button
        onClick={() => onNavigate('#/translate')}
        className="p-1 rounded hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors shrink-0"
        title="Trang chủ"
      >
        <Home className="w-3.5 h-3.5" />
      </button>

      {items.map((item, index) => (
        <React.Fragment key={item.hash}>
          <ChevronRight className="w-3 h-3 text-slate-300 shrink-0" />

          {item.isCurrent ? (
            <span className="font-bold text-slate-700 truncate max-w-[200px]">
              {item.label}
            </span>
          ) : (
            <button
              onClick={() => onNavigate(item.hash)}
              className="text-slate-400 hover:text-indigo-600 hover:underline transition-colors truncate max-w-[150px]"
            >
              {item.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
